var M, T, creator, fail, udDecompConstructor, udDecompPrototype;

M = require("./matrix");

creator = require("ut1l/create/object");

T = require("ut1l/create/throwable");

fail = T("MatrixException");

udDecompConstructor = function(A, T, U, D) {
  var i, j, k, s, _i, _j, _k, _ref, _ref1, _ref2;
  if (T == null) {
    T = A.clone();
  }
  if (U == null) {
    U = T;
  }
  if (D == null) {
    D = T;
  }
  if (!T.isSquare()) {
    fail("matrix must be square");
  }
  this.size = T.columns;
  for (j = _i = _ref = this.size - 1; _i >= 0; j = _i += -1) {
    for (i = _j = j; _j >= 0; i = _j += -1) {
      s = T.get(i, j);
      for (k = _k = _ref1 = j + 1, _ref2 = this.size; _k < _ref2; k = _k += 1) {
        s -= (U.get(i, k)) * (D.get(k, k)) * (U.get(j, k));
      }
      if (i === j) {
        D.set(j, j, s);
      } else {
        if ((D.get(j, j)) === 0) {
          fail("not a regular matrix");
        }
        U.set(i, j, s / D.get(j, j));
      }
    }
  }
  this.ud = T;
};

udDecompPrototype = {
  solveDiagonal: function(y, t) {
    var i, j, _i, _j, _ref, _ref1;
    if (t == null) {
      t = y.clone();
    }
    for (i = _i = 0, _ref = this.size; _i < _ref; i = _i += 1) {
      for (j = _j = 0, _ref1 = y.columns; _j < _ref1; j = _j += 1) {
        t.set(i, j, y.get(i, j) / this.ud.get(i, i));
      }
    }
    return t;
  },
  solveUnitTriangular: function(y, transp, t) {
    var i, j, k, _i, _j, _k, _l, _m, _n, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
    if (t == null) {
      t = y.clone();
    }
    if (transp) {
      for (j = _i = 0, _ref = y.columns; _i < _ref; j = _i += 1) {
        for (i = _j = 0, _ref1 = this.size; _j < _ref1; i = _j += 1) {
          t.set(i, j, y.get(i, j));
          for (k = _k = 0; _k < i; k = _k += 1) {
            t.set(i, j, (t.get(i, j)) - (this.ud.get(k, i)) * (t.get(k, j)));
          }
        }
      }
    } else {
      for (j = _l = 0, _ref2 = y.columns; _l < _ref2; j = _l += 1) {
        for (i = _m = _ref3 = this.size - 1; _m >= 0; i = _m += -1) {
          t.set(i, j, y.get(i, j));
          for (k = _n = _ref4 = i + 1, _ref5 = this.size; _n < _ref5; k = _n += 1) {
            t.set(i, j, (t.get(i, j)) - (this.ud.get(i, k)) * (t.get(k, j)));
          }
        }
      }
    }
    return t;
  },
  solve: function(y, t) {
    if (t == null) {
      t = y.clone();
    }
    this.solveUnitTriangular(y, false, t);
    this.solveDiagonal(t, t);
    this.solveUnitTriangular(t, true, t);
    return t;
  }
};

module.exports = creator(udDecompConstructor, udDecompPrototype);
